import { useFormik } from 'formik';
import { getAluno } from '../../../api/aluno';
import { validateCupom, doPayment, doPaymentBoleto, doPaymentPix } from '../../../api/pagamento';
import { getPlano } from '../../../api/plano';
import { handleAddress } from '../../../api/cep';
import ErrorMsg, { ErrorApiMsg, SuccessApiMsg } from './error-msg';
import { assineAgoraSchema, assineAgoraSemCadastroSchema } from './validation-schema';
import { React, useEffect, useState, useCallback } from 'react';
import { retrieveToken } from './../../../hooks/use-token';
import { useNavigate } from "react-router-dom";
import pagarme from 'pagarme/browser'
import { useGoogleReCaptcha } from  'react-google-recaptcha-v3';

const CheckoutForm = ({cdPlano}) => {
    
    const [apiErrors, setApiErrors] = useState(null);
    const [apiSuccess, setApiSuccess] = useState(null);
    const [cupomErrors, setCupomErrors] = useState(null);
    const [cupomSuccess, setCupomSuccess] = useState(null);
    const [typeCupom, setTypeCupom] = useState(null);
    const [valueCupom, setValueCupom] = useState(null);
    const [isSubmting, setIsSubmiting] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [dadosPlano, setDadosPlano] = useState(null);
    const [dadosAluno, setDadosAluno] = useState(null);
    const [dadosCep, setDadosCep] = useState(null); 
    const [showCreditCard, setShowCreditCard] = useState(false);
    const [emailExists, setEmailExists] = useState(false);
    const tokenApi = retrieveToken();
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const initialValuesFormAssinar = { name: '', email: '', cpf: '', telefone: '', bairro: '', numero: '', cidade: '', cep: '', endereco: '', complemento: '', estado: '', formaPagamento: '', nome_dono_cartao: '', numero_cartao: '', mes: '', ano: '', cvv: '', parcelas: '' };
    const initialValuesFormAssinarSemCadastro = { name: '', email: '', email_confirme: '', password: '', passwordConfirmation: '', cpf: '', telefone: '', bairro: '', numero: '', cidade: '', cep: '', endereco: '', complemento: '', estado: '', formaPagamento: '', nome_dono_cartao: '', numero_cartao: '', mes: '', ano: '', cvv: '', parcelas: '' };
    const handleReCaptchaVerify = useCallback(async () => {
        
        if (!executeRecaptcha) {
            console.log('executeRecaptcha not yet available');
            return;
        }
        
        const token = await executeRecaptcha('signup');
        
        return token;
        
    }, [executeRecaptcha]);
    
    useEffect(() => {
        console.log('typeCupom', typeCupom);
    }, [typeCupom])
    
    useEffect(() => {
        
        if (dadosPlano == null) {
            
            getPlano(tokenApi, cdPlano).then(function(result) {
                setDadosPlano(result);
            });
            
        }
        
        if (dadosAluno == null && tokenApi) {
            
            getAluno(tokenApi).then(function(result) {
                setDadosAluno(result);
                setFieldValue('name', result.nome);
                setFieldValue('email', result.email);
                if (result.email != '') {
                    setEmailExists(true);
                }
                setFieldValue('cpf', (result.cpf != null) ? result.cpf : '');
                setFieldValue('telefone', (result.telefone != null) ? result.telefone.replace(/\D/g, '') : '');
                setFieldValue('instagram', (result.instagram != null) ? result.instagram : '');
            });
            
        }
        
    }, []);
    
    const handleCardHash = async (cardNumber, cardHolderName, cardExpirationDate, Cvv) => {
        
        const card = {
            card_number: cardNumber,
            card_holder_name: cardHolderName,
            card_expiration_date: cardExpirationDate,
            card_cvv: Cvv,
        }
        
        let cardValidations = pagarme.validate({card: card});
        
        if (cardValidations.card.card_cvv == false) {
            setApiErrors("Erro! Verifique o código de segurança"); 
            return false;
        } else if (cardValidations.card.card_expiration_date == false) {
            setApiErrors("Erro! Verifique a data de validade do seu cartão, informe mês e o ano no outro campo"); 
            return false;
        } else if (cardValidations.card.card_holder_name == false) {
            setApiErrors("Erro! Digite o nome completo do dono do cartão, sem acentos."); 
            return false;
        } else if (cardValidations.card.card_number == false) {
            setApiErrors("Erro! Verifique o número do cartão digitado, informe somente números, sem espaços ou hífen."); 
            return false;
        } else {
            
            const options = {
                method: 'POST',
                headers: {accept: 'application/json', 'content-type': 'application/json'},
                body: JSON.stringify({
                    card: {
                        number: card.card_number.replace(/\D/g, ''),
                        holder_name: card.card_holder_name,
                        exp_month: parseInt(card.card_expiration_date.slice(0, 2)),
                        exp_year: parseInt(card.card_expiration_date.slice(2)),
                        cvv: card.card_cvv
                    },
                    type: 'card'
                })
            };
            
            return await fetch('https://api.pagar.me/core/v5/tokens?appId=pk_n1Ag8rtEOHPZprk3', options)
            .then(response => response.json())
            .then(response => {
                console.log(response);
                return response;
            })
            .catch(err => {
                console.error(err)
                return "Erro! Requisição é inválida, verifique todos os dados do cartão e o CPF digitado.";
            });

        }
        
    }
    
    const removeAcentosECaracteresEspeciais = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, "");
    };
    
    // form
    const handleOnSubmit = async (values, { resetForm }) => {
        
        const token = await handleReCaptchaVerify();
        
        console.log('token => ' + token);
        
        if (!token) {
            setApiErrors("Erro ao verificar reCAPTCHA.");
            setIsSubmiting(false);
            return;
        }

        values.recaptchaToken = token;
        
        setIsSubmiting(true);
        
        if (paymentMethod === 'credit_card') {
            
            handleCardHash(values.numero_cartao, removeAcentosECaracteresEspeciais(values.nome_dono_cartao), values.mes+values.ano, values.cvv).then((cardHash) => {
                
                console.log('cardHash', cardHash)

                if (cardHash.id) {
                    
                    setIsSubmiting(true);
                    setApiErrors(null);
                    setApiSuccess(null);
                    
                    const tokenApi = retrieveToken();
                    
                    doPayment(tokenApi, {
                        "nome_dono_cartao": values.nome_dono_cartao,
                        "card_hash": cardHash.id,
                        "name": values.name,
                        "email": values.email,
                        "cpf": values.cpf, 
                        "telefone": values.telefone,
                        "bairro": values.bairro,
                        "numero": values.numero,
                        "cidade": values.cidade,
                        "endereco": values.endereco,
                        "cep": dadosCep,
                        "complemento": values.complemento,
                        "estado": values.estado,
                        "formaPagamento": values.formaPagamento,
                        "parcelas": values.parcelas,
                        "plano": dadosPlano.cd_plano,
                        "cupom": values.cupom,
                        "recaptchaToken": values.recaptchaToken,
                        "password": (dadosAluno == null) ? values.password : false,
                        "createAluno": (dadosAluno == null) ? true : false
                    }).then(res => {
                        
                        if (res.status) {
                            setApiSuccess('Seu pedido foi processado! Aguarde que você será redirecionado..');
                            resetForm();
                            navigate(`/pagamento-finalizado?transaction=${res.id}&transactionStatus=${res.status}`);
                        } else
                        setApiErrors(res.message); 
                        
                        setIsSubmiting(false); 
                        
                    }).catch(error => {
                        
                        console.log('Error:', error);
                        
                        setApiErrors("Desculpe, não foi possível completar a sua requisição. #1"); 
                        setIsSubmiting(false);
                        
                    });
                    
                }
            })
            
        } else if (paymentMethod === 'boleto') {
            
            //boleto
            setIsSubmiting(true);
            setApiErrors(null);
            setApiSuccess(null);
            
            const tokenApi = retrieveToken();
            
            doPayment(tokenApi, {
                "name": values.name,
                "email": values.email,
                "cpf": values.cpf, 
                "telefone": values.telefone,
                "bairro": values.bairro,
                "numero": values.numero,
                "cidade": values.cidade,
                "endereco": values.endereco,
                "cep": dadosCep,
                "complemento": values.complemento,
                "estado": values.estado,
                "formaPagamento": values.formaPagamento,
                "plano": dadosPlano.cd_plano,
                "cupom": values.cupom,
                "recaptchaToken": values.recaptchaToken,
                "password": (dadosAluno == null) ? values.password : false,
                "createAluno": (dadosAluno == null) ? true : false
            }).then(res => {
                
                console.log(res.status)
                
                if (res.status) {
                    setApiSuccess('Seu pedido foi processado! Aguarde que você será redirecionado..');
                    resetForm();
                    navigate(`/pagamento-finalizado?transaction=${res.id}&transactionStatus=${res.status}&linkBoleto=${res.charges[0].last_transaction.pdf}`);
                } else

                setApiErrors(res.message); 
                setIsSubmiting(false); 
                
            }).catch(error => {
                
                console.log('Error:', error);
                
                setApiErrors("Desculpe, não foi possível completar a sua requisição. #2"); 
                setIsSubmiting(false);
                
            });
            
        } else {
            
            //pix
            setIsSubmiting(true);
            setApiErrors(null);
            setApiSuccess(null);
            
            const tokenApi = retrieveToken();
            
            doPayment(tokenApi, {
                "name": values.name,
                "email": values.email,
                "cpf": values.cpf, 
                "telefone": values.telefone,
                "bairro": values.bairro,
                "numero": values.numero,
                "cidade": values.cidade,
                "endereco": values.endereco,
                "cep": dadosCep,
                "complemento": values.complemento,
                "estado": values.estado,
                "formaPagamento": values.formaPagamento,
                "plano": dadosPlano.cd_plano,
                "cupom": values.cupom,
                "recaptchaToken": values.recaptchaToken,
                "password": (dadosAluno == null) ? values.password : false,
                "createAluno": (dadosAluno == null) ? true : false
            }).then(res => {
                
                if (res.status) {
                    setApiSuccess('Seu pedido foi processado! Aguarde que você será redirecionado..');
                    resetForm();
                    navigate(`/pagamento-finalizado?transaction=${res.id}&transactionStatus=${res.status}&pixQrCode=${res.charges[0].last_transaction.qr_code_url}`);
                } else
                    setApiErrors(res.message); 
                
                setIsSubmiting(false); 
                
            }).catch(error => {
                
                console.error('Error:', error);
                
                setApiErrors("Desculpe, não foi possível completar a sua requisição. #3"); 
                setIsSubmiting(false);
                
            });
            
        }
        
    }
    
    const handleValidateCupom = () => {
        
        setCupomErrors(null);
        setCupomSuccess(null);
        
        validateCupom(tokenApi, {
            "cd_plano": cdPlano,
            "cupom": values.cupom
        }).then(function(result) {
            if (result.error) {
                setCupomErrors(result.error);
            } else {
                
                if (result.porcentagem > 0) {
                    setTypeCupom("Porcentagem");
                    setValueCupom(result.porcentagem);
                } else if (result.valor > 0) {
                    setTypeCupom("Valor");
                    setValueCupom(result.valor);
                }
                
                setCupomSuccess("Seu cupom foi aplicado com sucesso!")
            }
        });
    }
    
    // use formik
    const { handleChange, handleSubmit, handleBlur, errors, values, touched, setFieldValue } = useFormik({
        validateOnChange: false, 
        validateOnBlur: false, 
        initialValues: (dadosAluno == null) ? initialValuesFormAssinarSemCadastro : initialValuesFormAssinar,
        validationSchema: (dadosAluno == null) ? assineAgoraSemCadastroSchema : assineAgoraSchema,
        onSubmit: handleOnSubmit,
    });
    
    useEffect(() => {
        const countErrorMessages = Object.values(errors).filter((error) => error).length;
        if (countErrorMessages > 0) {
            setApiErrors("Existem campos obrigatórios não preenchidos. Verifique e tente novamente."); 
        } else {
            setApiErrors(null);
        }
    }, [errors]);
    
    function buildParcelamento(numeroParcelas) {
        
        const parcelas = [];
        
        for (let i = 1; i <= numeroParcelas; i++) {
            parcelas.push(
                <option value={i}>{i}x</option>
            );
        }
        
        return (parcelas);
    }
    
    function handleChangeCep(value) {
        if (value.length >= 8) {
            
            let cep = value.replace(/\D/g, '');
            
            setDadosCep(cep);
            
            handleAddress(cep).then(function(result) {
                if (!result.erro) {
                    setFieldValue('bairro', result.bairro);
                    setFieldValue('cidade', result.localidade);
                    setFieldValue('endereco', result.logradouro);
                    setFieldValue('estado', result.uf);
                } else {
                    setApiErrors('CEP não encontrado'); 
                }
            });
            
        }
    }
    
    if (dadosPlano != null) {
        
        return (
            <section className="checkout-area pb-70">
            <div className="container">
            <form onSubmit={handleSubmit} autoComplete="new-payment">
            <div className="row">
            <div className="col-lg-6">
            <div className="checkbox-form">
            <h3>Seus dados</h3>
            <div className="row">
            
            <div className="col-md-12">
            <div className="checkout-form-list">
            <label>Nome completo <span className="required">*</span></label>
            <input onChange={handleChange} onBlur={handleBlur} value={values.name} name="name" type="text" placeholder="Nome completo" autoComplete="off" />
            {touched.name && <ErrorMsg error={errors.name} />}
            </div>
            </div>
            
            
            {dadosAluno == null && 
                
                <div className="col-md-6 col-xs-12">
                    <div className="checkout-form-list">
                    <label>Informe seu e-mail <span className="required">*</span></label>
                    <input onChange={handleChange} onBlur={handleBlur} value={values.email} name="email" type="text" placeholder="E-mail" autoComplete="off" />
                    {touched.email && <ErrorMsg error={errors.email} />}
                    </div>
                </div>
            }
            {dadosAluno == null && 
                <div className="col-md-6 col-xs-12">
                    <div className="checkout-form-list">
                    <label>Confirme seu e-mail <span className="required">*</span></label>
                    <input onChange={handleChange} onBlur={handleBlur} value={values.email_confirme} name="email_confirme" type="text" placeholder="Confirme seu e-mail" autoComplete="off" />
                    {touched.email && <ErrorMsg error={errors.email} />}
                    </div>
                </div>
            }
            {dadosAluno == null && 
                <div className="col-md-6 col-xs-12">
                <h5>Senha</h5>
                <div className="checkout-form-list">
                <input value={values.password} onChange={handleChange} onBlur={handleBlur} 
                type="password" placeholder="Sua senha" name='password' />
                {touched.password && <ErrorMsg error={errors.password} />}
                </div>
                </div>
            }
            {dadosAluno == null && 
                <div className="col-md-6 col-xs-12">
                <h5>Confirme a sua senha</h5>
                <div className="checkout-form-list">
                <input value={values.passwordConfirmation} onChange={handleChange} onBlur={handleBlur}  
                type="password" placeholder="Confirme a senha" name='passwordConfirmation' />
                {touched.passwordConfirmation && <ErrorMsg error={errors.passwordConfirmation} />}
                </div>
                </div>
            }

            {dadosAluno != null &&
            <div className="col-md-12">
                <div className="checkout-form-list">
                <label>E-mail da sua conta {(emailExists ? '(somente leitura)' : '')}<span className="required">{(emailExists ? '' : '*')}</span></label>
                <input onChange={handleChange} onBlur={handleBlur} value={values.email} name="email" type="text" placeholder="E-mail" disabled={emailExists} autoComplete="off" />
                {touched.email && <ErrorMsg error={errors.email} />}
                </div>
            </div>
            }
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>CPF <span className="required">*</span></label>  
            <input onChange={(e) => { if (/^\d*$/.test(e.target.value)) handleChange(e); }} onBlur={handleBlur} value={values.cpf} name="cpf" type="text" placeholder="Somente números" maxLength="11" autoComplete="off" />
            {touched.cpf && <ErrorMsg error={errors.cpf} />}
            </div>
            </div>
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>Celular c/ DDD <span className="required">*</span></label>
            <input onChange={(e) => { if (/^\d*$/.test(e.target.value)) handleChange(e); }} onBlur={handleBlur} value={values.telefone} name="telefone" type="text" placeholder="Somente números" maxLength="11" autoComplete="off" />
            {touched.telefone && <ErrorMsg error={errors.telefone} />}
            </div>
            </div>
            
            </div>
            <h3>Endereço</h3>
            <div className="row">
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>CEP <span className="required">*</span></label>
            <input name="cep" type="text" placeholder="Digite o Cep (somente números)" value={values.cep}
            onChange={(e) => {
                handleChangeCep(e.target.value);
                handleChange(e);
            }} maxLength="8" onBlur={handleBlur} 
            autoComplete="off"
            />
            {touched.cep && <ErrorMsg error={errors.cep} />}
            </div>
            
            </div>
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>Endereço (Av., Rua) <span className="required">*</span></label>
            <input value={values.endereco} onChange={handleChange} onBlur={handleBlur} name="endereco" type="text" placeholder="Endereço" autoComplete="off" />
            {touched.endereco && <ErrorMsg error={errors.endereco} />}
            </div>
            
            </div>
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>Número <span className="required">*</span></label>
            <input value={values.numero} onChange={handleChange} onBlur={handleBlur} name="numero" type="text" placeholder="Número" autoComplete="off" />
            {touched.numero && <ErrorMsg error={errors.numero} />}
            </div>
            
            </div>
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>Complemento </label>
            <input value={values.complemento} onChange={handleChange} onBlur={handleBlur} name="complemento" type="text" placeholder="Complemento" autoComplete="off" />
            {touched.bairro && <ErrorMsg error={errors.bairro} />}
            </div>
            
            </div>
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>Bairro <span className="required">*</span></label>
            <input value={values.bairro} onChange={handleChange} onBlur={handleBlur} name="bairro" type="text" placeholder="Bairro" autoComplete="off" />
            {touched.bairro && <ErrorMsg error={errors.bairro} />}
            </div>
            
            </div>
            
            <div className="col-md-6">
            <div className="checkout-form-list">
            <label>Cidade <span className="required">*</span></label>
            <input value={values.cidade} onChange={handleChange} onBlur={handleBlur} name="cidade" type="text" placeholder="Cidade" autoComplete="off" />
            {touched.cidade && <ErrorMsg error={errors.cidade} />}
            </div>
            
            </div>
            
            <div className="col-md-12">
            <div className="country-select">
            <label>Estado <span className="required">*</span></label>
            <select name="estado" onChange={handleChange} onBlur={handleBlur} value={values.estado} autoComplete="off">
            <option value="">Selecione</option>
            <option value="AC">Acre</option>
            <option value="AL">Alagoas</option>
            <option value="AP">Amapá</option>
            <option value="AM">Amazonas</option>
            <option value="BA">Bahia</option>
            <option value="CE">Ceará</option>
            <option value="DF">Distrito Federal</option>
            <option value="ES">Espirito Santo</option>
            <option value="GO">Goiás</option>
            <option value="MA">Maranhão</option>
            <option value="MS">Mato Grosso do Sul</option>
            <option value="MT">Mato Grosso</option>
            <option value="MG">Minas Gerais</option>
            <option value="PA">Pará</option>
            <option value="PB">Paraíba</option>
            <option value="PR">Paraná</option>
            <option value="PE">Pernambuco</option>
            <option value="PI">Piauí</option>
            <option value="RJ">Rio de Janeiro</option>
            <option value="RN">Rio Grande do Norte</option>
            <option value="RS">Rio Grande do Sul</option>
            <option value="RO">Rondônia</option>
            <option value="RR">Roraima</option>
            <option value="SC">Santa Catarina</option>
            <option value="SP">São Paulo</option>
            <option value="SE">Sergipe</option>
            <option value="TO">Tocantins</option>
            </select>
            {touched.uf && <ErrorMsg error={errors.uf} />}
            </div>
            
            </div>
            
            </div>
            
            </div>
            </div>
            <div className="col-lg-6">
            <div className="your-order mb-30 ">
            <h3>Seu pedido</h3>
            <div className="your-order-table table-responsive">
            <table>
            <thead>
            <tr>
            <th className="product-name">Plano</th>
            <th className="product-total text-end">Total</th>
            </tr>
            </thead>
            <tbody>
            
            <tr key="0" className="cart_item">
            <td className="product-name">
            <strong className="product-quantity"> × 1</strong> {dadosPlano.titulo} 
            </td>
            <td className="product-total text-end">
            <span className="amount">R$ {dadosPlano.valor_promocao // casas decimais
                .replace('.', ',')
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}</span>
                </td>
                </tr>
                
                {cupomSuccess !== null && <>
                    <tr key="0" className="cart_item">
                    <td className="product-name">
                    <strong className="product-quantity">Cupom</strong> {(typeCupom == 'Porcentagem') ? valueCupom+'%' : 'R$'+valueCupom // casas decimais
                        .replace('.', ',')
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')} 
                        </td>
                        <td className="product-total text-end">
                        <span className="amount">- R$ {(typeCupom == 'Porcentagem') ? (dadosPlano.valor_promocao*valueCupom/100).toString() // casas decimais
                            .replace('.', ',')
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : valueCupom // casas decimais
                            .replace('.', ',')
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}</span>
                            </td>
                            </tr>
                            </>}
                            
                            </tbody>
                            
                            </table>
                            </div>
                            
                            <div className="payment-method">
                            <div className="accordion" id="accordionExample">
                            <h4>Cupom</h4>
                            <div className="your-order-table table-responsive">
                            <p>Digite o seu cupom de desconto:</p>
                            <div className="col-md-12">
                            <div className="checkout-form-list">
                            <input style={{width: "50%"}} value={values.cupom} name="cupom" type="text" onChange={handleChange} onBlur={handleBlur} placeholder="Cupom" /> <button onClick={handleValidateCupom} type="button" className="btn btn-outline-secondary" autoComplete="off"> { (isSubmting) ? <span><i className="fal fa-spinner"></i></span> : 'Aplicar' }</button>
                            {touched.cupom && <ErrorMsg error={errors.cupom} />}
                            {cupomErrors && <ErrorApiMsg error={cupomErrors} />}
                            {cupomSuccess && <SuccessApiMsg msg={cupomSuccess} />}
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>
                            
                            <h3 style={{marginTop: "20px"}}>Forma de pagamento</h3>
                            
                            <div className="payment-method">
                            <div className="accordion" id="accordionExample">
                            
                            <div className="form-check">
                            <input className="form-check-input" type="radio" value="credito" name="formaPagamento" id="formaPagamento1" onChange={(e) => {
                                setShowCreditCard(true);
                                setPaymentMethod("credit_card");
                                setFieldValue('formaPagamento', "credit_card");
                            }} />
                            <label className="form-check-label" htmlFor="formaPagamento1">
                            Cartão de Crédito
                            </label>
                            </div>
                            
                            <div className="form-check">
                            <input className="form-check-input" type="radio" value-="boleto" name="formaPagamento" id="formaPagamento2" onChange={(e) => {
                                setShowCreditCard(false);
                                setPaymentMethod("boleto");
                                setFieldValue('formaPagamento', "boleto");
                            }} />
                            <label className="form-check-label" htmlFor="formaPagamento2">
                            Boleto Bancário
                            </label>
                            </div>
                            
                            <div className="form-check">
                            <input className="form-check-input" type="radio" value-="pix" name="formaPagamento" id="formaPagamento3" onChange={(e) => {
                                setShowCreditCard(false);
                                setPaymentMethod("pix");
                                setFieldValue('formaPagamento', "pix");
                            }} />
                            <label className="form-check-label" htmlFor="formaPagamento2">
                            PIX
                            </label>
                            </div>
                            
                            {touched.formaPagamento && <ErrorMsg error={errors.formaPagamento} />}
                            
                            { showCreditCard && <div className="row" style={{marginTop: "20px"}}>
                            
                            <div className="col-md-12">
                            <div className="checkout-form-list">
                            <label>Nome completo dono do cartão <span className="required">*</span></label>
                            <input value={values.nome_dono_cartao} name="nome_dono_cartao" type="text" onChange={handleChange} onBlur={handleBlur} placeholder="Digite o nome dono do cartão" />
                            {touched.nome_dono_cartao && <ErrorMsg error={errors.nome_dono_cartao} />}
                            </div>
                            </div>

                            <div className="col-md-12">
                            <div className="checkout-form-list">
                            <label>Número do cartão <span className="required">*</span></label>
                            <input value={values.numero_cartao} maxLength={16} name="numero_cartao" type="text" onChange={handleChange} onBlur={handleBlur} placeholder="Digite o número do cartão" />
                            {touched.numero_cartao && <ErrorMsg error={errors.numero_cartao} />}
                            </div>
                            </div>
                            
                            <div className="col-md-4">
                            <div className="country-select">
                            <label>Mês <span className="required">*</span></label>
                            <select value={values.mes} name="mes" onChange={handleChange} onBlur={handleBlur}>
                                <option value="">MM</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select>
                            {touched.mes && <ErrorMsg error={errors.mes} />}
                            </div>
                            </div>
                            
                            <div className="col-md-4">
                            <div className="country-select">
                            <label>Ano <span className="required">*</span></label>
                            <select value={values.ano} name="ano" onChange={handleChange} onBlur={handleBlur}>
                                <option value="">AA</option>
                                {Array.from({length: 10}, (v, k) => k + new Date().getFullYear()).map(ano => <option value={ano.toString().slice(-2)} key={ano}>{ano}</option>)}
                            </select>
                            {touched.ano && <ErrorMsg error={errors.ano} />}
                            </div>
                            </div>
                            
                            <div className="col-md-4">
                            <div className="checkout-form-list">
                            <label>Código (CVV) <span className="required">*</span></label>
                            <input value={values.cvv} maxLength="4" name="cvv" type="text" onChange={handleChange} onBlur={handleBlur} placeholder="CVV" />
                            {touched.cvv && <ErrorMsg error={errors.cvv} />}
                            </div>
                            </div>
                            
                            <div className="col-md-12">
                            <div className="country-select">
                            <label>Selecione o número de parcelas <span className="required">*</span></label>
                            <select name="parcelas" onChange={handleChange} onBlur={handleBlur} value={values.parcelas}>
                            {dadosPlano.map}
                            <option value="">Selecione</option>
                            {buildParcelamento(dadosPlano.parcelas)}
                            </select>
                            {touched.parcelas && <ErrorMsg error={errors.parcelas} />}
                            </div>
                            </div>
                            
                            </div> }
                            
                            </div>
                            
                            <div className="order-button-payment mt-20">
                            <button type="submit" className="e-btn e-btn-7 w-100">{ (isSubmting) ? <span><i className="fal fa-spinner"></i></span> : 'Realizar Pagamento' }</button>
                            </div>
                            <div style={{marginTop: "20px"}}>
                            {apiErrors && <ErrorApiMsg error={apiErrors} />}
                            {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
                            </div>
                            </div>
                            </div>
                            </div>
                            </div>
                            </form>
                            </div>
                            </section>
                        );
                        
                    }
                    
                };
                
                export default CheckoutForm;